export interface CaseStudy {
  slug: string;
  client: string;
  industry: string;
  challenge: string;
  result: string;
  metrics: { label: string; value: string }[];
  quote: string;
  author: string;
  role: string;
}

export const CASES: CaseStudy[] = [
  {
    slug: "agency-pixel",
    client: "Digital-агентство «Пиксель»",
    industry: "Performance-агентство, 40+ клиентов",
    challenge: "Команда из 3 человек тратила до 200 часов/мес на ручную маркировку. Получали 1–2 предупреждения от ФАС в квартал.",
    result: "После подключения ERIDON: 0 штрафов за 8 месяцев, маркировка автоматизирована на 96%, время на 1 креатив — с 30 минут до 4 секунд.",
    metrics: [
      { label: "Часов сэкономлено / мес", value: "180+" },
      { label: "Штрафов за 8 мес", value: "0" },
      { label: "ROI подписки", value: "1 240%" },
    ],
    quote: "Самый недооценённый инструмент в нашем стеке. Раньше юрист проверял каждый пост, теперь — только спорные.",
    author: "Дмитрий Петров",
    role: "CEO",
  },
  {
    slug: "shop-volkov",
    client: "Интернет-магазин «Волков-Декор»",
    industry: "E-commerce, рекламный бюджет 1,8 млн ₽/мес",
    challenge: "Калькулятор риска показал потенциальный штраф 4,5 млн ₽ за 6 месяцев непромаркированных кампаний.",
    result: "Оперативная маркировка всех активных креативов, выпуск 312 erid за первый день, подключение автоматических отчётов в ЕРИР.",
    metrics: [
      { label: "Креативов промаркировано", value: "312" },
      { label: "Штраф предотвращён", value: "≈ 4,5 млн ₽" },
      { label: "Окупаемость", value: "1 день" },
    ],
    quote: "Подписка окупилась за первый день. Не понимаю, как я раньше работал без этого.",
    author: "Максим Волков",
    role: "Владелец",
  },
  {
    slug: "blogger-kovaleva",
    client: "Блогер Анна Ковалёва (210k подписчиков)",
    industry: "Lifestyle, 8–12 интеграций в месяц",
    challenge: "После штрафа партнёра на 100 000 ₽ занялась маркировкой самостоятельно, тратила 2 часа на каждую интеграцию.",
    result: "Перешла на ERIDON Lite: маркировка прямо из Telegram-бота, отчёты в ЕРИР собираются автоматически.",
    metrics: [
      { label: "Часов на 1 интеграцию", value: "2 ч → 4 мин" },
      { label: "Штрафов за год", value: "0" },
      { label: "Стоимость / мес", value: "1 425 ₽" },
    ],
    quote: "Я не юрист и не хочу им быть. ERIDON делает скучную часть работы за меня.",
    author: "Анна Ковалёва",
    role: "Контент-креатор",
  },
];
